"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Hug: ()=>Hug
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_Badge_index_cjs_namespaceObject = require("../Badge/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Heading_index_cjs_namespaceObject = require("../Heading/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_Hug_variants_cjs_namespaceObject = require("./Hug.variants.cjs");
function Hug({ heading, helperText, iconName, badgeLabel, customHeader, body, footer, className, palette, emphasis, ...props }) {
    const { hugContainerSlot, headingSlot, headingWrapperSlot, iconSlot, badgeSlot } = (0, external_Hug_variants_cjs_namespaceObject.hugVariants)({
        palette,
        emphasis,
        ...props
    });
    const containerClass = (0, index_cjs_namespaceObject.cn)(hugContainerSlot(), className);
    const renderHeader = !!heading || !!customHeader;
    const renderHugHeader = ()=>{
        if (customHeader) return customHeader;
        if (heading) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                iconName && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: iconSlot(),
                    "data-testid": "hug-icon-wrapper",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                        iconName: iconName,
                        size: "24",
                        palette: palette,
                        shade: 'bold' === emphasis ? '9' : '8'
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: headingWrapperSlot(),
                    "data-testid": "hug-heading-wrapper",
                    children: [
                        badgeLabel && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Badge_index_cjs_namespaceObject.Badge, {
                            className: badgeSlot(),
                            emphasis: 'neutral' === palette && 'regular' !== emphasis ? 'regular' : 'medium',
                            palette: 'primary' === palette ? 'promoPrimary' : 'neutral',
                            children: badgeLabel
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Heading_index_cjs_namespaceObject.Heading, {
                            as: "h5",
                            palette: "primary",
                            shade: 'bold' === emphasis ? '1' : '13',
                            children: heading
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                            textStyle: "body2",
                            palette: "primary",
                            shade: 'bold' === emphasis ? '1' : '13',
                            children: helperText
                        })
                    ]
                })
            ]
        });
    };
    const innerContent = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            renderHeader && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: headingSlot(),
                "data-testid": "hug-header",
                children: renderHugHeader()
            }),
            body,
            footer
        ]
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: containerClass,
        "data-testid": "hug-container",
        children: innerContent
    });
}
exports.Hug = __webpack_exports__.Hug;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Hug"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
